import { useField } from 'formik';
import InputMask from 'react-input-mask';

const MaskedInput = ({ name, ...props }) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (e) => {
    helpers.setValue(e.target.value);
  };

  return (
    <div>
      <InputMask
        mask="(999) 999-9999"
        maskChar={null}
        value={field.value || ''}
        onChange={handleChange}
        onBlur={() => helpers.setTouched(true)}
      >
        {(inputProps) => (
          <input
            {...inputProps}
            type="tel"
            inputMode="tel"
            className="input no-spinner"
            placeholder="(123) 456-7890"
            {...props}
          />
        )}
      </InputMask>
      {meta.touched && meta.error && (
        <p className="text-red-500 text-[11px] mt-1">{meta.error}</p>
      )}
    </div>
  );
};

export { MaskedInput };
